import { CommonBaseModel } from "./common.model";

export interface IOrganisation {
    extendedProperties: object;
    enabled: boolean;
    formVault: boolean;
    baseOrganisation: boolean;
    organisationName: string;
    organisationHandle: string;
    parentOrganisationId: string;
    themes: string[];
    defaultTheme: string;
    siteSettings: SiteSettings;
}

export class Organisation extends CommonBaseModel implements IOrganisation {
    id: string = undefined;
    extendedProperties: object = {};
    enabled: boolean;
    formVault: boolean;
    baseOrganisation: boolean;
    organisationName!: string;
    organisationHandle: string;
    parentOrganisationId: string = null;
    themes: string[] = [];
    defaultTheme: string = null;
    siteSettings: SiteSettings = new SiteSettings();

    init(_data?: any): this
    {
        super.init(_data);
        if (_data) {
            // this.extendedProperties = _data["ExtendedProperties"];
            // this.enabled = _data["Enabled"];
            // this.formVault = _data["FormVault"];
            // this.baseOrganisation = _data["BaseOrganisation"];
            // this.organisationName = _data["OrganisationName"];
            // this.organisationHandle = _data["OrganisationHandle"];
            // this.parentOrganisationId = _data["ParentOrganisationId"];
            this.initArray(this, 'themes', _data["Themes"]);
            // this.defaultTheme = _data["DefaultTheme"];
            this.siteSettings = (new SiteSettings()).init(_data["SiteSettings"]);
        }

        return this;
    }

    static fromJS(data: any): Organisation {
        return new Organisation().init(data);
    }

    // static fromJS(data: any): Organisation {
    //     data = typeof data === 'object' ? data : {};
    //     let result = new Organisation();
    //     result.init(data);
    //     return result;
    // }

    // toJSON(data?: any) {
    //     data = typeof data === 'object' ? data : {};
    //     data["ExtendedProperties"] = this.ExtendedProperties;
    //     data["Enabled"] = this.Enabled;
    //     data["FormVault"] = this.FormVault;
    //     data["BaseOrganisation"] = this.BaseOrganisation;
    //     data["OrganisationName"] = this.OrganisationName;
    //     data["OrganisationHandle"] = this.OrganisationHandle;
    //     data["ParentOrganisationId"] = this.ParentOrganisationId;
    //     data["Themes"] = this.Themes;
    //     data["DefaultTheme"] = this.DefaultTheme;
    //     data["SiteSettings"] = this.SiteSettings;
    //     return data;
    // }
}


export interface ISiteSettings {
    Url: string;
    RelativeUrl: string;
    FromEmailAddress: string;
    EmailLinksBaseUrl: string;
    Analytics: AnalyticEngine[];
}

export class SiteSettings extends CommonBaseModel implements ISiteSettings
{
    Url: string;
    RelativeUrl: string;
    FromEmailAddress: string;
    EmailLinksBaseUrl: string;
    Analytics: AnalyticEngine[];

    // constructor(data?: ISiteSettings) {
    //     if (data) {
    //         for (let property in data) {
    //             if (data.hasOwnProperty(property))
    //                 (<any>this)[property] = (<any>data)[property];
    //         }
    //     }
    // }

    init(_data?: any): this
    {
        super.init(_data);
        // if (_data) {
        //     this.Url = _data["Url"];
        //     this.RelativeUrl = _data["RelativeUrl"];
        //     this.FromEmailAddress = _data["FromEmailAddress"];
        //     this.EmailLinksBaseUrl = _data["EmailLinksBaseUrl"];
        //     this.Analytics = _data["Analytics"];
        // }
        return this;
    }

    static fromJS(data: any): SiteSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SiteSettings();
        result.init(data);
        return result;
    }

    // toJSON(data?: any) {
    //     data = typeof data === 'object' ? data : {};
    //     data["Url"] = this.Url;
    //     data["RelativeUrl"] = this.RelativeUrl;
    //     data["FromEmailAddress"] = this.FromEmailAddress;
    //     data["EmailLinksBaseUrl"] = this.EmailLinksBaseUrl;
    //     data["Analytics"] = this.Analytics;
    //     return data;
    // }
}

export interface IAnalyticEngine {
    Type: string;
    TrackingId: string;
}

export class AnalyticEngine
{
    Type: string;
    TrackingId: string;

    constructor(data?: IAnalyticEngine) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Type = _data["Type"];
            this.TrackingId = _data["TrackingId"];
        }
    }

    static fromJS(data: any): AnalyticEngine {
        data = typeof data === 'object' ? data : {};
        let result = new AnalyticEngine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.Type;
        data["TrackingId"] = this.TrackingId;
        return data;
    }
}
